function SearchIcon() {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 11.6834H11.71L11.43 11.4173C12.41 10.2937 13 8.83505 13 7.24823C13 3.70991 10.09 0.841797 6.5 0.841797C2.91 0.841797 0 3.70991 0 7.24823C0 10.7865 2.91 13.6547 6.5 13.6547C8.11 13.6547 9.58999 13.0731 10.73 12.1073L11 12.3832V13.1619L16 18.08L17.49 16.6115L12.5 11.6834ZM6.5 11.6834C4.01 11.6834 2 9.70238 2 7.24823C2 4.79407 4.01 2.81301 6.5 2.81301C8.99 2.81301 11 4.79407 11 7.24823C11 9.70238 8.99 11.6834 6.5 11.6834Z"
        fill="#8C8C8C"
      />
    </svg>
  );
}

export default SearchIcon;
